var React = require('react');

function SeverityChangeSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#525C6A","fillRule":"evenodd","d":"M14.082 1.75c.09-.544-.353-.935-.969-.777-3.007.997-5.266 4.276-5.52 7.512-.23 2.664.138 3.942.254 4.53-.283-.19-.74-.586-1.215-1.34-.253-.442-.582-1.053-1.014-2.552-.171-.537-.88-.763-1.282-.186-.025.056-2.059 3.49-1.612 6.902.278 3.109 2.799 7.528 8.87 7.597 3.972.057 6.594-1.984 7.57-3.433.806-1.16 1.685-2.63 1.77-5.177.086-2.548-.638-3.792-1.043-4.583-.394-.599-1.344-2.35-1.176-3.628.052-.3-.055-.976-.869-.86-.205.063-2.138.89-2.448 4.126-1.98-2.966-1.463-7.432-1.316-8.132Z","clipRule":"evenodd"}));
}

SeverityChangeSmall.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = SeverityChangeSmall;

SeverityChangeSmall.default = SeverityChangeSmall;
